import React from "react";
import "./CustomNavbar.scss";
import {
	MDBModal, MDBModalBody,
	MDBNavbar,
	MDBNavbarBrand,
	MDBNavbarNav,
	MDBNavItem,
} from "mdbreact";
import {Slide} from "react-reveal";
import AddMoney from "../../pages/UserWallet/AddMoney";
import WithdrawMoney from "../../pages/UserWallet/WithdrawMoney";
import CashDetail from "../../pages/UserWallet/CashDetail";
import {withRouter} from "react-router-dom";
import WelcomeCardBanner from "../WelcomBannerCard/WelcomeCardBanner";
import {connect} from "react-redux";
import LandingBannerCard from "../LandingBannerCard/LandingBannerCard";
import NetWorthModal from "../../pages/UserWallet/NetWorthModal";
import {assetUrl} from "../../serviceApi";
import Skeleton from "react-loading-skeleton";
import Login from "../../pages/Login/Login";

const search = assetUrl + 'images/search-icon-white.svg';
const NotificationIcon = assetUrl + "images/notification-icon-white.svg";
const NotificationIconEmpty = assetUrl + "images/Notifications-bell-empty-white.svg";
const WalletIcon = assetUrl + "images/white-wallet.svg";
const bgRound = assetUrl + "images/circle.svg";

class CustomNavbar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			// walletModal: false,
			currentModal: "",
			theposition: window.pageYOffset,
			notification: [],
			bgShow: false,
			login_modal:false
		}
	}

	setActiveModal = (args) => {
		this.setState({
			currentModal: args,
		})
	}

	checkUserLoggedIn = (action) => {
		if(this.props.logged_in === false){
			this.openLoginModal();
		} else if(action === "wallet") {
			this.setState({currentModal: "cash"})
		} else if(action === "notification") {
			this.props.history.push("/notification")
		}
	}
	openLoginModal = () => {
		this.setState({
			login_modal:true
		});
	}
	closeLoginModal = () => {
		this.setState({
			login_modal:false
		});
	}
	completeLogin = () => {
		this.closeLoginModal();
		window.location.reload();
		// this.getWalletData();
	}

	render() {
		let bgPink = {backgroundColor: '#242426'}

		setTimeout(() => {
			this.setState({bgShow: true})
		}, 2000)

		return (
			<>
				<div className={"custom-navbar-component"}>
					<div className={this.props.newUser ? "header-wrap-newuser" : "header-wrap"}>
						{
							this.state.bgShow && <img src={bgRound} alt={"alt"}
													  className={this.props.newUser ? "round-pattern-big animate__animated animate__zoomIn animate__delay-1s" : "round-pattern animate__animated animate__zoomIn "}/>

						}

						<MDBNavbar style={bgPink} dark expand="xs" scrolling fixed="top" id={"navbar"}>
							<MDBNavbarBrand>
								<img src={search} alt={"search"} className={"img-fluid "}
									 onClick={() => this.props.history.push("/all-stocks")}/>
							</MDBNavbarBrand>
							<p className={"app-title"}>NETA</p>
							<MDBNavbarNav>
								<MDBNavItem className={""}>
									<a className={"nav-link"}>
										<img src={WalletIcon} alt={"search"} className={"img-fluid"}
											 onClick={()=>this.checkUserLoggedIn("wallet")}
											// onClick={() => this.setState({...this.state, currentModal: "cash"})}
										/>
									</a>
								</MDBNavItem>
								<MDBNavItem className={""}>
									<a className={"nav-link"}>
										<img
											src={this.state.notification.length > 0 ? NotificationIcon : NotificationIconEmpty}
											alt={"search"} className={"img-fluid bell-icon"}
											onClick={()=>this.checkUserLoggedIn("notification")}
											// onClick={() => this.props.history.push("/notification")}
										/>
									</a>
								</MDBNavItem>
							</MDBNavbarNav>
						</MDBNavbar>



						{
							this.props.loading ?
								<Skeleton width={"100%"} height={"190px"} style={{borderBottomLeftRadius:"24px"}}/>
								:
								<>
									{
										this.props.logged_in ?
											<div className={"mt-5 pt-3 py-1"}>
												{(this.props.newUser && this.props.newUser.newUserPortfolio && this.props.page === "main") ?
													<div className={"px-4"}><WelcomeCardBanner
														currentModal={(args) => this.setState({currentModal: args})}
														walletData={this.props.walletData}
														openLoginModal={this.openLoginModal}
													/></div>
													:
													<LandingBannerCard
														currentModal={(args) => this.setState({currentModal: args})}
														loading={this.props.loading}
														walletData={this.props.walletData}
													/>
												}
											</div>
											:
											<div className={"mt-5 pt-3 py-1"}>
												<div className={"px-4"}>
													<WelcomeCardBanner
														currentModal={(args) => this.setState({currentModal: args})}
														walletData={this.props.walletData}
														openLoginModal={this.openLoginModal}
													/>
												</div>
											</div>
									}
								</>

						}

					</div>
					<MDBModal fullHeight={false} position="bottom" overflowScroll={true} inline={false}
							  noClickableBodyWithoutBackdrop={false} isOpen={this.state.currentModal !== ""}>
						<MDBModalBody>
							{
								this.state.currentModal === "add" ?
									<AddMoney
										setActiveModal={(args) => this.setActiveModal(args)}
										user_details={this.props.user_details}
									/> :
									this.state.currentModal === "withdraw" ?
										<WithdrawMoney
											setActiveModal={(args) => this.setActiveModal(args)}
											user_details={this.props.user_details}
										/> :
										this.state.currentModal === "cash" ?
											<CashDetail setActiveModal={(args) => {

												this.setActiveModal(args)
											}}/> :
											this.state.currentModal === "walletData" ?
												<NetWorthModal wallet_data={this.props.walletData}
															   setActiveModal={(args) => {

																   this.setActiveModal(args)
															   }}/> :
												null
							}

						</MDBModalBody>
					</MDBModal>

				</div>
				<Login isOpen={this.state.login_modal}
					   closeModal={this.closeLoginModal}
					   completeLogin={this.completeLogin}
				/>
			</>

		);
	}
}

const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details,
	logged_in: state.UserReducer.logged_in

});

export default connect(mapStateToProps)(withRouter(CustomNavbar));
